var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 0.65625C5.8125 0.46875 6.15625 0.46875 6.34375 0.65625L11.3438 5.65625C11.5312 5.84375 11.5312 6.1875 11.3438 6.375C11.1562 6.5625 10.8125 6.5625 10.625 6.375L6 1.71875L1.34375 6.375C1.15625 6.5625 0.8125 6.5625 0.625 6.375C0.4375 6.1875 0.4375 5.84375 0.625 5.65625L5.625 0.65625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.348ffde471bb6479c3e1097518f86385.svg";
export { ForwardRef as ReactComponent };